import { createSelector } from 'reselect';

import {
  selectFlyoutCategoriesCategories,
} from 'core/modules/FlyoutCategories/selectors';

const selectRelatedCategoryFeaturedStores = state => state.relatedCategoryFeaturedStores;

export const selectRelatedCategoryFeaturedStoresConfig = createSelector(
  selectRelatedCategoryFeaturedStores,
  relatedCategoryFeaturedStores => relatedCategoryFeaturedStores.config,
);

// Pick top 2 categories tagged with the deactivated store
// that intercept with the category ordering specified for the client
export const makeSelectRelatedCategoryFeaturedStoresData = () => (
  createSelector(
    [
      (state, merchant) => merchant,
      selectFlyoutCategoriesCategories,
      selectRelatedCategoryFeaturedStoresConfig,
    ],
    (merchant, flyoutCategories, config) => {
      const { maxCategories, maxFeaturedMerchantsPerCategory } = config;
      const relatedCategoryIds = merchant.categories ? merchant.categories.map(({ id }) => id) : [];

      return flyoutCategories.reduce((acc, category) => {
        const hasFeaturedMerchants = category.featured && category.featured.length > 0;
        if (relatedCategoryIds.indexOf(category.id) !== -1 && hasFeaturedMerchants) {
          acc.push({
            ...category,
            merchants: category.featured.slice(0, maxFeaturedMerchantsPerCategory).map(({ merchant }) => merchant),
          });
        }
        return acc;
      }, []).slice(0, maxCategories);
    },
  )
);
